import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { 
  getAuth, 
  connectAuthEmulator, 
  Auth, 
  EmailAuthProvider, 
  reauthenticateWithCredential,
  User
} from 'firebase/auth';
import { getStorage, connectStorageEmulator, FirebaseStorage } from 'firebase/storage';
import { firebaseConfig } from '../config/firebase-config';

console.log('Initializing Firebase...');

// Initialize Firebase only if no apps exist
let app: FirebaseApp;
if (getApps().length === 0) {
  console.log('Creating new Firebase app...');
  app = initializeApp(firebaseConfig);
} else {
  console.log('Using existing Firebase app...');
  app = getApps()[0];
}

// Initialize Firebase Authentication
console.log('Initializing Firebase Auth...');
const auth: Auth = getAuth(app);
console.log('Firebase Auth initialized successfully');

// Initialize Firebase Storage
console.log('Initializing Firebase Storage...');
const storage: FirebaseStorage = getStorage(app);
console.log('Firebase Storage initialized successfully');

// Connect to Auth emulator in development if needed
if (process.env.NODE_ENV === 'development') {
  // Use setTimeout to ensure the auth instance is fully initialized
  setTimeout(() => {
    try {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
      console.log('Connected to Auth emulator');
    } catch (error) {
      console.log('Auth emulator not available or already connected:', error);
    }
  }, 100);
  
  // Connect to Storage emulator in development if needed
  try {
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('Connected to Storage emulator');
  } catch (error) {
    console.log('Storage emulator not available or already connected:', error);
  }
}

console.log('Firebase initialization complete');

export { 
  auth, 
  storage,
  EmailAuthProvider, 
  reauthenticateWithCredential,
};
export type { User };
export default app; 